<script>
  import * as restfulService from '../../../../../../../app/services/restfulService'
  import * as notifyService from '../../../../../../../app/services/notifyService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import {required, minLength} from 'vuelidate/lib/validators'

  export default {
    mixins: [helpers],
    name: 'paper-show-evaluation-appraisers',
    props: ['paper', 'reviews', 'evaluationType'],
    data () {
      return {
        isSubmitted: false,
        isSearchingAppraiser: false,
        dependencies: {
          appraisers: [],
          filteredAppraisers: []
        },
        appraisers: []
      }
    },
    validations: function () {
      return {
        appraisers: {
          required,
          minLength: minLength(this.showEvaluations ? 1 : (this.evaluationType ? this.minEvaluations : 0)),
          $each: {
            appraiser_id: {required}
          }
        }
      }
    },
    computed: {
      minEvaluations: function () {
        return this.evaluationType ? (this.evaluationType.min_evaluations_number - this.reviews.length) : 0
      }
    },
    mounted () {
      let appraisers = []
      for (let i = 0; i < this.minEvaluations; i++) {
        appraisers.push({
          appraiser_id: ''
        })
      }
      this.appraisers = [...appraisers]
      this.getAppraisers(this.paper.event_paper_type.event_id)
    },
    methods: {
      addSingleAppraiser () {
        if (this.appraisers.length === 0) {
          this.getAppraisers(this.paper.event_paper_type.event_id)
        }
        this.appraisers.push({appraiser_id: ''})
        this.$v.appraisers.$reset()
      },
      getAppraisers (eventId) {
        this.dependencies.appraisers.splice(0)
        this.dependencies.filteredAppraisers.splice(0)
        let data = {event_id: eventId}
        restfulService.post('registration', 'appraisers', null, data)
          .then(response => {
            response.forEach((item) => {
              item.show = true
            })
            this.dependencies.appraisers = [...response]
            this.dependencies.filteredAppraisers = [...response]
          })
          .catch(e => {
            console.log(e)
          })
      },
      selectAppraiser () {
        this.dependencies.appraisers.forEach((item) => {
          item.show = !this.appraisers.some(appraiser => appraiser.appraiser_id === item.id)
        })
      },
      removeAppraiser (index) {
        this.appraisers.splice(index, 1)
        this.selectAppraiser()
      },
      onAssignAppraisers () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {
          id: this.paper.id,
          evaluation_type_id: this.evaluationType.id,
          appraisers: this.appraisers
        }
        restfulService.post('paper', 'assign-appraisers', data.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            bus.$emit('papers-reload-list')
            this.isSubmitted = false
          })
          .catch(e => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <table class="table-confirmation" style="margin-top: 15px;"
           v-if="evaluationType.evaluation_opened || evaluationType.evaluation_finished">
        <thead>
        <tr>
            <th>Atribuir Avaliadores</th>
            <th>
                <el-button type="success"
                           size="mini"
                           v-if="!evaluationType.evaluation_finished"
                           @click="addSingleAppraiser">
                    <i class="fa fa-plus"></i>
                    <span>Adicionar Avaliador</span>
                </el-button>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td colspan="2">
                <el-form ref="formPaper"
                         :model="paper"
                         label-width="20%">
                    <el-form-item
                            v-for="(item, index) in appraisers"
                            label="Avaliador"
                            class="is-required"
                            v-bind:class="{ 'el-form-item--error': $v.appraisers.$each[index].appraiser_id.$error }">
                        <el-row :gutter="10">
                            <el-col :span="20">
                                <el-select v-model="item.appraiser_id"
                                           clearable
                                           filterable
                                           placeholder="Digite o nome do avaliador"
                                           no-data-text="Nenhum registro encontrado"
                                           no-match-text="Nenhum registro encontrado"
                                           @change="selectAppraiser"
                                           class="el-select-full"
                                           @input="$v.appraisers.$each[index].appraiser_id.$touch()">
                                    <el-option v-for="item in dependencies.filteredAppraisers"
                                               class="el-select-appraisers"
                                               :key="item.id"
                                               v-show="item.show && item.evaluation_types.some(obj => obj.evaluation_type_id === evaluationType.evaluation_type_id)"
                                               :label="item.name"
                                               :value="item.id">
                                        <div class="item-name">{{ item.name }} ({{ item.ref_pessoa }})
                                        </div>
                                        <div class="item-description"
                                             v-if="item.knowledge_areas.length > 0">
                                             Graduação: {{item.grade}}<br>
                                             Áreas de Conhecimento: {{item.knowledge_areas.map(obj => obj.knowledge_area.name).join(', ')}}
                                        </div>
                                    </el-option>
                                </el-select>
                                <validation-message
                                        v-if="!$v.appraisers.$each[index].appraiser_id.required && $v.appraisers.$each[index].appraiser_id.$dirty"/>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="danger"
                                           @click="removeAppraiser(index)"
                                           v-if="!evaluationType.evaluation_finished"
                                           size="mini"
                                           title="Remover Avaliador">
                                    <i class="fa fa-times"></i>
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success"
                                   @click="onAssignAppraisers"
                                   :disabled="isSubmitted || $v.appraisers.$invalid">
                            <i class="fa fa-check"></i>
                            <span>Atribuir Avaliadores</span>
                        </el-button>
                    </el-form-item>
                </el-form>
            </td>
        </tr>
        </tbody>
    </table>
</template>



// WEBPACK FOOTER //
// Appraisers.vue?762b720b